/** Decorative swirl badges used behind circular stats. */
export const SWIRL_3_SVG_PATH = '/svg/swirl-3.svg';
export const SWIRL_3_SVG_WIDTH = 261;
export const SWIRL_3_SVG_HEIGHT = 261;

export const SWIRL_4_SVG_PATH = '/svg/swirl-4.svg';
export const SWIRL_4_SVG_WIDTH = 246;
export const SWIRL_4_SVG_HEIGHT = 244;

/** Figma Stat / Graph Stat swirl rotations (degrees). */
export const STAT_CIRCLE_SWIRL_ROTATE_STAT = -45;
export const STAT_CIRCLE_SWIRL_ROTATE_POD = -150;
